import { render, staticRenderFns } from "./phoneTab.vue?vue&type=template&id=52f21970&scoped=true"
import script from "./phoneTab.vue?vue&type=script&lang=js"
export * from "./phoneTab.vue?vue&type=script&lang=js"
import style0 from "./phoneTab.vue?vue&type=style&index=0&id=52f21970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f21970",
  null
  
)

export default component.exports